import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 * 出差登记
 */
export class ApplyEvectionRegistrationReimbursementApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-evection-registration-reimbursement'
    }




}
